import React from "react";
import { cn } from "../../lib/cn";

export interface ChipProps {
  label: React.ReactNode;
  onRemove?: () => void;
  size?: "sm" | "md";
  className?: string;
}

/** Removable tag. Consolidates the hand-rolled chip in BatchTrackModal + share's Chip. */
export const Chip: React.FC<ChipProps> = ({ label, onRemove, size = "md", className }) => (
  <span
    className={cn(
      "inline-flex items-center gap-2 bg-surface-2 border border-border rounded-full text-body",
      size === "sm" ? "px-2.5 py-1 text-[12px]" : "px-3 py-[6px] text-[13px]",
      className,
    )}
  >
    {label}
    {onRemove && (
      <button
        type="button"
        aria-label="Remove"
        onClick={(e) => { e.stopPropagation(); onRemove(); }}
        className="text-muted hover:text-white transition-colors inline-flex [&_svg]:w-[13px] [&_svg]:h-[13px]"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    )}
  </span>
);

export default Chip;
